"use strict";
exports.__esModule = true;
var ChartDimension = /** @class */ (function () {
    function ChartDimension(_a) {
        var id = _a.id, label = _a.label, displayOrder = _a.displayOrder, columns = _a.columns, columnType = _a.columnType;
        var _this = this;
        this.toJSON = function () { return ({
            id: _this.id,
            label: _this.label,
            displayOrder: _this.displayOrder,
            columns: _this.columns,
            columnType: _this.columnType
        }); };
        this.id = id;
        this.label = label;
        this.displayOrder = displayOrder;
        this.columns = columns;
        this.columnType = columnType;
    }
    ChartDimension.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, label = _a.label, displayOrder = _a.displayOrder, columns = _a.columns, columnType = _a.columnType;
        if (typeof id !== 'string')
            throw new Error('.id must be a string');
        if (typeof label !== 'string')
            throw new Error('.label must be a string');
        if (typeof displayOrder !== 'number' && displayOrder !== undefined && displayOrder !== null)
            throw new Error('.displayOrder must be a number');
        if (!Array.isArray(columns) && columns !== undefined && columns !== null)
            throw new Error('.columns must be an array');
        if (columnType !== 'DATE' && columnType !== 'TIME_RANGE' && columnType !== undefined)
            throw new Error('.type must be a ColumnType');
        return new ChartDimension({
            id: id,
            label: label,
            displayOrder: displayOrder,
            columns: columns,
            columnType: columnType
        });
    };
    return ChartDimension;
}());
exports["default"] = ChartDimension;
